import React from 'react'
import { DashboardBabyContentContainer, TabContainer } from './styles'
import { Tabs } from '~/components/shared'
import { message } from '~/services'
import { OpenCloseProvider } from '~/context'
import { VaccinesProvider } from '~/context/vaccines'
import { Vaccines } from '~/components/generalMedicalView'
import {
  BabyGrowth,
  NeonatalScreening,
  TimelineMaternalInfant,
  MaternalInfantSidePanel
} from '~/components/maternalInfantMedicalView'
import { IPatient } from '~/interfaces'

interface IBabyTimelineViewProps {
  motherPatient: IPatient
  childPatient: IPatient
}

export const BabyTimelineView = ({ motherPatient, childPatient }: IBabyTimelineViewProps): JSX.Element => {
  return (
    <TabContainer>
      <Tabs>
        <Tabs.Options>
          <Tabs.Item>{message('maternalInfant.timeline')}</Tabs.Item>
          <Tabs.Item>{message('maternalInfant.neonatal_screening')}</Tabs.Item>
          <Tabs.Item>{message('maternalInfant.baby_growth_title')}</Tabs.Item>
          <Tabs.Item>{message('timeline.vaccines')}</Tabs.Item>
        </Tabs.Options>

        <Tabs.Content>
          <DashboardBabyContentContainer>
            <OpenCloseProvider>
              <TimelineMaternalInfant />
              <MaternalInfantSidePanel />
            </OpenCloseProvider>
          </DashboardBabyContentContainer>
          <NeonatalScreening />
          <BabyGrowth motherPatient={motherPatient} childPatient={childPatient} />
          <VaccinesProvider>
            <Vaccines />
          </VaccinesProvider>
        </Tabs.Content>
      </Tabs>
    </TabContainer>
  )
}
